// @flow
import throttle from "lodash/fp/throttle"
import curry from "lodash/fp/curry"

const throttleNotFixed = throttle.convert({ fixed: false })

// $FlowFixMe: error revealed by updating Flow and lodash libdef, please fix
export const throttleTrailing = curry((wait, fn) =>
  throttleNotFixed(wait)(fn, { leading: false, trailing: true }),
)

// $FlowFixMe: error revealed by updating Flow and lodash libdef, please fix
export const throttleLeading = curry((wait, fn) =>
  throttleNotFixed(wait)(fn, { leading: true, trailing: false }),
)
